const flights = {
  flight: "उड़ान", // translated 
  flights: "टिकट", // translated 
  originDepartureDate: "प्रस्थान", // translated 
  destinationDepartureDate: "वापस करना", // translated 
  outbound: "आउटबाउंड", // translated 
  inbound: "भीतर का", // translated 
  travelTime: "यात्रा के समय", // translated 
  selected: "चयनित", // translated 
  select: "चुनना", // translated 
  airline: "एयरलाइन", // translated 
  directFlight: "सीधी उड़ान", // translated 
  baggage: "सामान", // translated 
  stops: "बंद हो जाता है", // translated 
  nonStop: "लगातार", // translated 
  oneStopMax: "एक ही स्थान पर अधिकतम", // translated 
  twoStopsMax: "अधिकतम दो स्टॉप", // translated 
  anyStops: "किसी भी पड़ाव के साथ", // translated 
  smallBaggage: "छोटा सामान", // translated 
  bigBaggage: "बड़ा सामान", // translated 
  smallAndBigBaggage: "छोटा और बड़ा सामान", // translated 
  outboundStops: "बाहर जाने वाले पड़ाव", // translated 
  inboundStops: "इनबाउंड स्टॉप", // translated 
  selectAirline: "एयरलाइन का चयन करें", // translated 
  baggageOption: "सामान विकल्प", // translated 
  outboundDepartureAfter: "प्रस्थान के बाद", // translated 
  outboundArrivalAfter: "प्रस्थान आगमन के बाद", // translated 
  inboundDepartureAfter: "आने वाली प्रस्थान के बाद", // translated 
  inboundArrivalTimeAfter: "आने वाली आवक के बाद", // translated 
  flightClass: "उड़ान वर्ग", // translated 
  outboundDepAfter: "प्रस्थान के बाद", // translated 
  outboundArrivalAfrer: "आगमन के बाद", // translated 
  inboundDepAfter: "प्रस्थान के बाद", // translated 
  inboundArrivalAfter: "आगमन के बाद", // translated 
  airlines: "एयरलाइन(एं)", // translated 
  lessThan: "से कम", // translated 
  layover: "बढा-चढाकर मूल्यांकन", // translated 
  duration: "अवधि", // translated 
  noClassPreference: "कक्षा को प्राथमिकता नहीं दी जाती", // translated 
  economy: "अर्थव्यवस्था", // translated 
  business: "व्यापार", // translated 
  with: "साथ", // translated 
  without: "बिना", // translated 
  twoOrMore: "दो या अधिक", // translated 
  departure: "प्रस्थान", // translated 
  return: "वापस करना", // translated 
  submit: "जमा करना", // translated 
  priceLessThan: "कीमत इससे कम है", // translated 
  durationLessThan: "अवधि इससे कम", // translated 
  layoverLessThan: "लेओवर इससे कम", // translated 
  noLayover: "कोई ठहराव नहीं", // translated 
  durationLowestFirst: "अवधि (सबसे कम से शुरू)", // translated 
  durationHighestFirst: "अवधि (सबसे अधिक से शुरू)", // translated 
  idType: "आईडी प्रकार", // translated 
  idPassportCode: "पहचान पत्र/पासपोर्ट कोड", // translated 
  expirationDate: "समाप्ति तिथि", // translated 
  frequentFlyerNumber: "प्रायः उड़ाका संख्या", // translated 
  frequentFlyerAirline: "फ़्रीक्वेंट फ़्लायर एयरलाइन", // translated 
  dateOfBirth: "जन्म तिथि", // translated 
  infant: "शिशु", // translated 
  phone: "फ़ोन", // translated 
  title: "शीर्षक", // translated 
  noLuggageIncluded: "सामान ले जाने की अनुमति नहीं है।", // translated 
  includesLuggage: "सामान शामिल है", // translated 
  outboundFlight: "बाहर जाने वाली उड़ान", // translated 
  inboundFlight: "इनबाउंड उड़ान", // translated 
  flightNumber: "विमान संख्या", // translated 
  flightNumbers: "उड़ान संख्याएँ", // translated 
  cabinClassType: "केबिन क्लास प्रकार", // translated 
  class: "कक्षा", // translated 
  aircraft: "विमान", // translated 
  aircraftType: "विमान का प्रकार", // translated 
  airlineName: "एयरलाइन का नाम", // translated 
  no: "नहीं", // translated 
  yes: "हाँ", // translated 
  anyFlights: "कोई भी उड़ानें", // translated 
  oneStop: "एक बंद", // translated 
  direct: "प्रत्यक्ष", // translated 
  directFlights: "सीधी उड़ानें", // translated 
  all: "सभी", // translated 
  first: "पहला", // translated 
  premiumEconomy: "प्रेम अर्थव्यवस्था", // translated 
  withBaggageOnly: "केवल सामान के साथ", // translated 
  oneWay: "एक तरफ़ा रास्ता", // translated 
  roundTrip: "राउंड ट्रिप", // translated 
  withBaggage: "सामान के साथ", // translated 
  noBaggagePreference: "सामान के लिए कोई प्राथमिकता नहीं", // translated 
  noBaggage: "कोई सामान नहीं", // translated 
  requiredFields: "आवश्यक फील्ड्स", // translated 
  nonRequiredFields: "गैर-आवश्यक फ़ील्ड", // translated 
  cabinClass: "केबिन क्लास", // translated 
  brandName: "ब्रांड का नाम", // translated 
  performNewSearch: "नई खोज करें", // translated 
  outboundDeparture: "बहिर्गमन", // translated 
  inboundDeparture: "आने वाली प्रस्थान", // translated 
  created: "बनाया था", // translated 
  freeCancellationAvailable: "निःशुल्क रद्द करने की सुविधा उपलब्ध है", // translated 
  freeCancellationDeadline: "निःशुल्क रद्दीकरण की समय सीमा", // translated 
  externalReference: "बाह्य संदर्भ", // translated 
  outboundflightNumber: "आउटबाउंड उड़ान संख्या", // translated 
  inboundflightNumber: "आने वाली उड़ान संख्या", // translated 
  arrival: "आगमन", // translated 
  originAirport: "उत्पत्ति हवाई अड्डा", // translated 
};


export default flights;
